<template>
  <article class="knowledge-base" @click="goToKnowledgeBase">
    <v-icon x-large color="primary" class="mr-3">
      mdi-school-outline
    </v-icon>
    <div>
      <div class="knowledge-base__title">
        БАЗА ЗНАНИЙ
      </div>
      <div class="knowledge-base__subtitle">
        Обучение FAKT CRM
      </div>
    </div>
  </article>
</template>

<script>
  import RouteName from '@/models/enums/RouteName'

  export default {
    name: 'ProfileDrawerKnowledgeBase',
    methods: {
      goToKnowledgeBase () {
        this.$store.commit('app/hideProfileDrawer')
        if (this.$route.name !== RouteName.KnowledgeBase) {
          this.$router.push({ name: RouteName.KnowledgeBase })
        }
      },
    },
  }
</script>

<style scoped lang="less">
.knowledge-base {
  display: flex;
  align-items: center;
  cursor: pointer;

  &__title {
    margin-right: 5px;
  }

  &__subtitle {
    font-size: 13px;
    color: #BCC1C9;
  }
}
</style>
